import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style/principal.css"; // Import the CSS file
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import Leftnavigation from "./Leftnavigation";

const Principal = () => {
  const [principal, setPrincipal] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    education: "",
    profession: "",
    experience: "",
    image: null,
  });

  useEffect(() => {
    fetchPrincipalData();
  }, []);

  const fetchPrincipalData = async () => {
    try {
      const response = await axios.get("https://gptkpm.in/backend/admin/principal.php");
      setPrincipal(response.data);
      setFormData({
        name: response.data.name || "",
        education: response.data.education || "",
        profession: response.data.profession || "",
        experience: response.data.experience || "",
        image: response.data.image || null,
      });
    } catch (error) {
      console.error("Error fetching principal data:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      setFormData((prev) => ({ ...prev, image: base64String }));
    };
    reader.readAsDataURL(file);
  };

  const handleEditClick = () => setIsEditing(true);

  const handleSaveClick = async () => {
    if (!formData.name || !formData.education || !formData.profession || !formData.experience) {
      alert("Please fill out all fields.");
      return;
    }
    try {
      const response = await axios.post(
        "https://gptkpm.in/backend/admin/principal.php",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response.data.success) {
        alert("Update successful");
        setIsEditing(false);
        fetchPrincipalData();
      } else {
        alert("Update failed: " + response.data.error);
      }
    } catch (error) {
      console.error("Error updating principal data:", error);
      alert("An error occurred while updating the data.");
    }
  };

  if (!principal) return <div>Loading...</div>;

  return (
    <div id="main-1">
      <Header />
      <Leftnavigation />
      <h2>Principal Details</h2>

      <div className="principal-container">
        <div className="principal-card">
          {!isEditing ? (
            <>
              <div
                className="principal-image"
                style={{
                  backgroundImage: `url(data:image/jpeg;base64,${principal.image})`,
                }}
              ></div>
              <div className="principal-details">
                <h2>Name: {principal.name}</h2>
                <p>Education: {principal.education}</p>
                <p>Profession: {principal.profession}</p>
                <button
                  className="edit-button"
                  onClick={handleEditClick}
                  style={{ background: "#ff6f3d" }}
                >
                  Edit
                </button>
              </div>
            </>
          ) : (
            <div className="principal-details edit-form">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Name"
              />
              <input
                type="text"
                name="education"
                value={formData.education}
                onChange={handleInputChange}
                placeholder="Education"
              />
              <input
                type="text"
                name="profession"
                value={formData.profession}
                onChange={handleInputChange}
                placeholder="Profession"
              />
              <input type="file" onChange={handleFileChange} />
              <p>Note: If the update does not work, refresh the page.</p>
              <button onClick={handleSaveClick} style={{ background: "#ff6f3d" }}>
                Save
              </button>
            </div>
          )}
        </div>
        <div className="guidelines">
          <h3>Guidelines</h3>
          <ul>
            <h3>1.Photo Upload:</h3>
            <li>Ensure the uploaded image is high-resolution (minimum 1080x1080 pixels).</li>
            <li>Accept only professional photos (JPEG or PNG format).</li>
            <li>Restrict file size to a maximum of 5MB to optimize loading time.</li>
            <h3>2.Data Entry Process</h3>
            <li>Use the provided form to fill in the required fields. Ensure there are no missing fields, as all are mandatory.</li>
            <li>Double-check the information entered before submission.</li>
              <h3>3.Review and Approve</h3>
            <li>After data submission, review the uploaded data for correctness.</li>
            <li>Approve or reject the entry if there are any discrepancies.
            </li>
          
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Principal;
